module.exports = __webpack_public_path__ + "img/CRT_Weapon-Wand-03.d9007d7a.png";